// extracted by mini-css-extract-plugin
export var description = "Search-module--description--2d3b9";
export var searchform = "Search-module--searchform--40b9a";